/* PhotoHouse V6: desktop hover/focus for existing details navigation;
 * one sticky ATC proxy pointing at the real Kingdom product form;
 * chart image fallback only. No fetch/cart mutations, inventory, price estimation.
 */
(function(){
 'use strict';
 function all(root,query){return Array.prototype.slice.call(root.querySelectorAll(query));}
 function value(node){return node ? (node.textContent||'').trim():'';}
 function canHover(){return window.matchMedia('(min-width:949px) and (hover:hover) and (pointer:fine)').matches;}
 function initHover(){
  if(!document.body.classList.contains('ph-v3-header'))return;
  all(document,'.ph-v3__topbar-parent').forEach(function(menu){
   if(menu.dataset.phV6Hover==='1')return;
   menu.dataset.phV6Hover='1';
   var pending=null;
   function cancel(){if(pending!==null){clearTimeout(pending);pending=null;}}
   function close(){cancel();if(canHover()&&!menu.matches(':hover')&&!menu.contains(document.activeElement))menu.open=false;}
   function schedule(){cancel();pending=setTimeout(close,210);}
   menu.addEventListener('pointerenter',function(evt){if(evt.pointerType==='touch'||!canHover())return;cancel();menu.open=true;});
   menu.addEventListener('pointerleave',function(evt){if(evt.pointerType==='touch'||!canHover())return;schedule();});
   menu.addEventListener('focusin',function(){cancel();menu.open=true;});
   menu.addEventListener('focusout',schedule);
   menu.addEventListener('keydown',function(evt){if(evt.key==='Escape'){cancel();menu.open=false;var summary=menu.querySelector('summary');if(summary)summary.focus();}});
  });
 }
 function initChart(){
  all(document,'img[data-ph-v6-chart]').forEach(function(image){
   if(image.dataset.phV6Init==='1')return;
   image.dataset.phV6Init='1';
   function fallback(){
    if(image.dataset.phV6TriedFallback==='1')return;
    image.dataset.phV6TriedFallback='1';
    var alternative=image.getAttribute('data-ph-v6-fallback');
    if(alternative&&image.src!==alternative){
     image.src=alternative;
     var link=image.closest('[data-ph-v6-chart-link]');
     if(link)link.href=alternative;
    }
   }
   image.addEventListener('error',fallback);
   if(image.complete&&image.naturalWidth===0)fallback();
  });
 }
 function initSticky(article){
  if(!article||article.dataset.phV6Sticky==='1')return;
  var sectionId=(article.id||'').replace(/^section-/,'');
  var bar=all(document,'[data-ph-v6-atc]').find(function(el){return el.getAttribute('data-product-section')===sectionId;});
  var original=article.querySelector('.product__add-to-cart');
  if(!bar||!original)return;
  var trigger=bar.querySelector('[data-ph-v6-button]');
  var price=bar.querySelector('[data-ph-v6-price]');
  var selection=bar.querySelector('[data-ph-v6-selection]');
  var originalPrice=article.querySelector('.product__price--original');
  var v4Price=article.querySelector('[data-ph-v4-summary-price]');
  var selects=all(article,'select.product__variant');
  article.dataset.phV6Sticky='1';
  var firstPrice=true;
  function selected(){
   if(!selection)return;
   // A product with the automatic Shopify default variant has no customer-facing
   // selection. Suppress its placeholder without hiding genuine size/frame choices.
   var chosen=article.hasAttribute('data-single-variant') ? [] : selects.map(function(el){
    var item=el.selectedIndex>=0 ? el.options[el.selectedIndex] : null;
    var label=item ? (item.text||'').trim() : '';
    return /^(default title|כותרת ברירת מחדל)$/i.test(label) ? '' : label;
   }).filter(Boolean);
   selection.textContent=chosen.join(' · ');
   selection.hidden=chosen.length === 0;
  }
  function sync(){
   // Liquid seeded the selected variant price. Only copy Kingdom's display after
   // its price changes; don't replace it with a minimum product price on init.
   if(price&&!firstPrice){var priceSource=value(v4Price)||value(originalPrice);if(priceSource)price.textContent=priceSource;}
   var label=value(original.querySelector('.add-to-cart__text'));
   if(label)trigger.textContent=label;
   var disabled=original.disabled || original.getAttribute('aria-disabled')==='true' ||
     ['disabled','working','done','clear'].some(function(cls){return original.classList.contains(cls);});
   trigger.disabled=Boolean(disabled);
   trigger.setAttribute('aria-disabled',String(Boolean(disabled)));
   selected();
  }
  function resync(){firstPrice=false;sync();}
  var raf=0;
  function visibility(){
   if(raf)return;
   raf=requestAnimationFrame(function(){
    raf=0;
    var rect=original.getBoundingClientRect();
    var viewportHeight=window.innerHeight||document.documentElement.clientHeight;
    var onMobile=window.matchMedia('(max-width:767px)').matches;
    // Mobile buyers may still be ABOVE the normal buy button, e.g. while
    // viewing the gallery. Show the sticky CTA when the original is offscreen
    // in either direction, never while it is visible in the viewport.
    var offscreen=rect.bottom<0||(onMobile&&rect.top>viewportHeight);
    var show=original.isConnected&&offscreen&&!document.body.classList.contains('overflow-hidden');
    bar.classList.toggle('is-visible',show);
    document.body.classList.toggle('ph-v6-atc-shown',show);
   });
  }
  trigger.addEventListener('click',function(){if(trigger.disabled||!original.isConnected)return;original.click();resync();});
  new MutationObserver(sync).observe(original,{attributes:true,attributeFilter:['disabled','class','aria-disabled'],subtree:true,childList:true,characterData:true});
  if(originalPrice)new MutationObserver(resync).observe(originalPrice,{childList:true,characterData:true,subtree:true});
  if(v4Price)new MutationObserver(resync).observe(v4Price,{childList:true,characterData:true,subtree:true});
  selects.forEach(function(el){el.addEventListener('change',function(){selected();requestAnimationFrame(resync);});});
  if(window.jQuery&&window.jQuery.fn&&selects.length)window.jQuery(selects).on('change.phV6',function(){selected();requestAnimationFrame(resync);});
  window.addEventListener('scroll',visibility,{passive:true});
  window.addEventListener('resize',visibility,{passive:true});
  window.addEventListener('pageshow',visibility);
  selected();sync();visibility();
 }
 function mount(){
  if(!document.body||!document.body.classList.contains('ph-v6'))return;
  initHover();initChart();
  if(document.body.classList.contains('template-product')&&!document.body.classList.contains('template-product-portfolio')){
   all(document,'.product.page-section').forEach(initSticky);
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
 document.addEventListener('shopify:section:load',mount);
}());
